// hasPermi.js

export default {
    inserted: function (el, binding, vnode) {
        const permission = binding.value; // 获取指令的值，即需要的权限标识
        const userPermissions = window.localStorage.getItem("menuPermissions"); // 假设权限信息存在于 Vuex 中的 state 中
        if (!userPermissions.includes(permission)) {
            el.parentNode.removeChild(el); // 移除没有权限的元素
        }
    }
};
